export default "__VITE_ASSET__BnhwMu6p__"